import { SectionContainer } from "../atoms/containers/ContentContainers";
import { ClientsContent } from "../molecules/clients_content/ClientsContent";

export function Clients() {
	return (
		<SectionContainer id="clients" variant="light">
			<ClientsContent />
		</SectionContainer>
	);
}
